import { projectsV2UpdateIntelligenceSummaryMutation } from '@civilgrid/rest-client';
import { useMutation } from '@tanstack/react-query';

type UpdateIntelligenceSummaryMutationOptions = ReturnType<typeof projectsV2UpdateIntelligenceSummaryMutation>;

export function useUpdateIntelligenceSummary(options?: Partial<UpdateIntelligenceSummaryMutationOptions>) {
  return useMutation({ ...projectsV2UpdateIntelligenceSummaryMutation(), ...options });
}
